import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';

@Component({
  selector: 'fl-required-wrapper',
  templateUrl: './required-wrapper.component.html',
  styleUrls: ['./required-wrapper.component.scss'],
})
export class RequiredWrapperComponent implements OnInit, OnChanges {
  @ViewChild('requiredWrapper', {static:true})
  requiredWrapper: ElementRef<HTMLDivElement>;

  @Input()
  private value = null;

  constructor() { }

  ngOnInit() {
    this.handle();
  }

  ngOnChanges(_: SimpleChanges): void {
    this.handle();
  }

  handle = () => {
    if (this.requiredWrapper == undefined)
      return;

    if (this.value == undefined) {
      this.requiredWrapper.nativeElement.classList.remove('required-wrapper-valid');
      this.requiredWrapper.nativeElement.classList.add('required-wrapper-invalid');
    }
    else {
      this.requiredWrapper.nativeElement.classList.add('required-wrapper-valid');
      this.requiredWrapper.nativeElement.classList.remove('required-wrapper-invalid');
    }
  }
}
